import React from 'react'
import styled from 'styled-components'
import { ModuleGroupData, SubmenuItem } from './types'
import { SubmenuRow } from './SubmenuRow'

const SectionContainer = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
`

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
  margin-bottom: 4px;
`

const ModuleTitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const ModuleTitle = styled.h4`
  font-size: 13px;
  font-weight: 700;
  color: #1e293b;
  text-transform: uppercase;
  margin: 0;
`

const ModuleBadge = styled.span`
  background-color: #e0f2fe;
  color: #0284c7;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 12px;
`

const SubmenuLabelText = styled.span`
  display: block;
  font-size: 10px;
  color: #94a3b8;
  font-weight: 600;
  text-transform: uppercase;
  margin-top: 2px;
`

const BulkCheckboxGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`

const BulkCheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 700;
  color: #0284c7;
  cursor: pointer;
  user-select: none;
`

const CustomCheckbox = styled.input`
  width: 16px;
  height: 16px;
  accent-color: #0284c7;
  cursor: pointer;
`

interface ModuleSectionProps {
  moduleGroup: ModuleGroupData
  onModuleChange: (updatedModule: ModuleGroupData) => void
}

export const ModuleSection: React.FC<ModuleSectionProps> = ({ moduleGroup, onModuleChange }) => {
  const totalSubmenus = moduleGroup.submenus.length
  const activeSubmenusCount = moduleGroup.submenus.filter((s) => s.permissions.ver).length

  const isModuleVerChecked = !!moduleGroup.permissions?.ver

  const handleModuleVerToggle = () => {
    const nextVal = !isModuleVerChecked

    const newPermissions = {
      ...(moduleGroup.permissions || { ver: false, criar: false, editar: false, deletar: false }),
      ver: nextVal,
    }

    onModuleChange({ ...moduleGroup, permissions: newPermissions })
  }

  const handleSubmenuChange = (submenuId: string, updatedPermissions: SubmenuItem['permissions']) => {
    const updatedSubmenus = moduleGroup.submenus.map((s) => (s.id === submenuId ? { ...s, permissions: updatedPermissions } : s))
    onModuleChange({ ...moduleGroup, submenus: updatedSubmenus })
  }

  return (
    <SectionContainer>
      <HeaderRow>
        <ModuleTitleGroup>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <ModuleTitle>{moduleGroup.name}</ModuleTitle>
              <ModuleBadge>
                {activeSubmenusCount}/{totalSubmenus}
              </ModuleBadge>
            </div>
            <SubmenuLabelText>SUBMENU</SubmenuLabelText>
          </div>
        </ModuleTitleGroup>

        <BulkCheckboxGroup>
          <BulkCheckboxLabel>
            <CustomCheckbox
              type="checkbox"
              checked={isModuleVerChecked}
              onChange={handleModuleVerToggle}
            />
            ✓ VER
          </BulkCheckboxLabel>
        </BulkCheckboxGroup>
      </HeaderRow>

      {moduleGroup.submenus.map((submenu) => (
        <SubmenuRow key={submenu.id} submenu={submenu} onChange={handleSubmenuChange} />
      ))}
    </SectionContainer>
  )
}
